module.exports = __webpack_public_path__ + "img/oracle.37707760.png";